import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import { XYChart } from "@amcharts/amcharts4/charts";
import { XYChartPayload } from "@/models/XYChartPayload";

export default {
  drawXYChart(payload: XYChartPayload): XYChart {
    const chart = am4core.create(payload.ref, am4charts.XYChart);
    chart.paddingRight = 25;
    chart.logo.disabled = true;
    chart.data = payload.items;

    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = payload.yLabel;
    categoryAxis.renderer.minGridDistance = 1;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.grid.template.stroke = am4core.color(payload.color);
    categoryAxis.title.fill = am4core.color(payload.color);
    categoryAxis.renderer.labels.template.fill = am4core.color(payload.color);

    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.grid.template.stroke = am4core.color(payload.color);
    valueAxis.title.fill = am4core.color(payload.color);
    valueAxis.renderer.labels.template.fill = am4core.color(payload.color);

    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryY = payload.yLabel;
    series.dataFields.valueX = payload.xLabel;
    series.tooltipText = "{valueX.value}";
    series.columns.template.strokeOpacity = 0;
    series.columns.template.column.cornerRadiusBottomRight = 5;
    series.columns.template.column.cornerRadiusTopRight = 5;
    series.columns.template.fill = am4core.color("#FF5252");

    const labelBullet = series.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.horizontalCenter = "left";
    labelBullet.label.dx = 10;
    labelBullet.label.text = "{values.valueX.workingValue.formatNumber('#')}";
    labelBullet.locationX = 1;

    return chart;
  }
};
